"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var UpdateConstraintSerialiser = require("./update-constraint-serialiser");
/**
 * Serialiser for {@link SetTopicRequest}
 */
var SetTopicRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(SetTopicRequestSerialiserClass, _super);
    function SetTopicRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link SetTopicRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link SetTopicRequest} to be written
     */
    SetTopicRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        BEES.write(bos, value.topicType);
        Codec.writeBytes(bos, value.value);
        UpdateConstraintSerialiser.write(bos, value.constraint);
    };
    return SetTopicRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SetTopicRequestSerialiserClass = SetTopicRequestSerialiserClass;
/**
 * The {@link SetTopicRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SetTopicRequestSerialiser = new SetTopicRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/set-topic-request-serialiser.js
// module id = 1495
// module chunks = 0